import * as React from 'react';
import { createInheritedProvider } from '@shapeable/utils';
export var defaultSiteSidebarConfig = {
  showFullscreenButton: false,
  color: '#969696',
  width: 56,
  widthMenu: 64,
  isAvailable: function () {
    return false;
  }
};
export var SiteSidebarContext = React.createContext(defaultSiteSidebarConfig);
export var SiteSidebarProvider = createInheritedProvider(SiteSidebarContext);